import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2, X, Check } from 'react-feather'

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from '../../../../common'

export const OrigenesTable = ({ useFetchInit }) => {
    
    const {
        FetchData,
        Actions
    } = useFetchInit

    const { fetchAllOrigenes } = FetchData
    const { dataOrigenes, loadingFetchAllOrigenes } = fetchAllOrigenes

    const { 
        handleClickFetchSpecificOrigen,
        handleClickEnableDisableExpense,
        handleClickDeleteOrigen
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } = params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "nombre", headerName: "Nombre", minWidth: 400, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idorigen, estado } = params.data

                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        {(estado === 1) && (
                            <div>
                                <MenuItem
                                    onClick={() => handleClickFetchSpecificOrigen(idorigen)}
                                >
                                    <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Informacion" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickDeleteOrigen(idorigen)}
                                >
                                    <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                                    <ListItemText primary="Eliminar" />
                                </MenuItem>
                                <MenuItem
                                    onClick={() => handleClickEnableDisableExpense(idorigen, 0)}
                                >
                                    <ListItemIcon> <X color="black"/> </ListItemIcon>
                                    <ListItemText primary="Desactivar" />
                                </MenuItem>
                            </div>
                        )}
                        {(estado === 0) && (
                            <MenuItem
                                onClick={() => handleClickEnableDisableExpense(idorigen, 1)}
                            >
                                <ListItemIcon> <Check color="black"/> </ListItemIcon>
                                <ListItemText primary="Activar" />
                            </MenuItem>
                        )}
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllOrigenes) && (<LinearLoading/>)}
            <CustomTableData 
                rowConfig={dataOrigenes}
                columnConfig={columnConfig}
            />
        </div>
    )
}
